// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bcr-table-body-cell.mlb-red > div {\n  color: var(--mlb-red) !important;\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
